import { useEffect, useState } from "react";
import { getTicketActivity } from "../../services/ticket_service";
import "./TicketActivity.css";

function formatEventTime(value) {
	const date = new Date(value);
	return Number.isNaN(date.getTime()) ? "" : date.toLocaleString([], {
		month: "short",
		day: "numeric",
		hour: "numeric",
		minute: "2-digit",
	});
}

export default function TicketActivity({ ticketType, ticketId, onOpenTicket }) {
	const [events, setEvents] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	useEffect(() => {
		let cancelled = false;
		if (!ticketType || !ticketId) {
			setEvents([]);
			return undefined;
		}

		setLoading(true);
		setError("");
		getTicketActivity(ticketType, ticketId)
			.then((rows) => {
				if (!cancelled) setEvents(Array.isArray(rows) ? rows : []);
			})
			.catch((nextError) => {
				if (!cancelled) setError(nextError?.message || "Failed to load activity");
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});

		return () => {
			cancelled = true;
		};
	}, [ticketType, ticketId]);

	return (
		<section className="it-ticket-activity" aria-label="Activity">
			<header className="it-ticket-activity-header">
				<h3>Activity</h3>
				<p>Key ticket events and operational changes.</p>
			</header>
			{error ? <p className="it-ticket-activity-error" role="alert">{error}</p> : null}
			{loading ? <p className="it-ticket-activity-empty">Loading activity...</p> : events.length === 0 ? (
				<p className="it-ticket-activity-empty">No activity has been recorded yet.</p>
			) : (
				<ol className="it-ticket-activity-list">
					{events.map((event) => (
						<li key={event.id} className="it-ticket-activity-event">
							<div className="it-ticket-activity-event-meta">
								<strong>{event.actor_name || "System"}</strong>
								<span>{formatEventTime(event.created_at)}</span>
							</div>
							{event.related_ticket_type && event.related_ticket_id ? (
								<button type="button" className="it-ticket-activity-link" onClick={() => onOpenTicket?.(event.related_ticket_type, { id: event.related_ticket_id })} disabled={!onOpenTicket}>{event.message}</button>
							) : <p>{event.message}</p>}
						</li>
					))}
				</ol>
			)}
		</section>
	);
}